import { C } from '../data';
import { useCart } from '../context/CartContext';
import Img from './Img';

export default function CartDrawer({ onCheckout }) {
  const { items, removeItem, updateQty, total, count, cartOpen, setCartOpen } = useCart();

  if (!cartOpen) return null;

  return (
    <>
      <div
        style={{ position:'fixed', inset:0, zIndex:3000, background:'rgba(26,26,26,.35)', animation:'fadeIn .2s' }}
        onClick={() => setCartOpen(false)}
      />
      <div style={{
        position:'fixed', top:0, right:0, bottom:0, zIndex:3001,
        width:'100%', maxWidth:440,
        background:C.bg, display:'flex', flexDirection:'column',
        boxShadow:'-8px 0 32px rgba(0,0,0,.08)',
        animation:'slideInRight .28s cubic-bezier(.25,.46,.45,.94)',
      }}>
        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'20px 28px', borderBottom:`1px solid ${C.border}` }}>
          <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:11, letterSpacing:3 }}>
            장바구니 {count > 0 && <span style={{ color:C.muted }}>({count})</span>}
          </span>
          <button onClick={() => setCartOpen(false)} style={{ background:'none', border:'none', cursor:'pointer', fontSize:20, color:C.muted, lineHeight:1, padding:'2px 4px' }}>✕</button>
        </div>

        {/* Items */}
        <div style={{ flex:1, overflowY:'auto' }}>
          {items.length === 0 ? (
            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%', flexDirection:'column', gap:12 }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={C.border} strokeWidth="1.2">
                <path d="M6 2 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 01-8 0"/>
              </svg>
              <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:C.muted, letterSpacing:1 }}>장바구니가 비어있습니다</p>
            </div>
          ) : items.map(item => (
            <div key={item.key} style={{ display:'flex', gap:16, padding:'18px 28px', borderBottom:`1px solid ${C.border}` }}>
              {/* Image */}
              <div style={{ width:76, flexShrink:0, aspectRatio:'3/4', overflow:'hidden', background:C.bg2 }}>
                {item.img
                  ? <img src={item.img} style={{ width:'100%', height:'100%', objectFit:'cover' }} alt={item.productName} />
                  : <Img style={{ width:'100%', height:'100%' }} label="" />
                }
              </div>
              {/* Info */}
              <div style={{ flex:1, display:'flex', flexDirection:'column', justifyContent:'space-between', minWidth:0 }}>
                <div>
                  <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, marginBottom:5, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{item.productName}</p>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, color:C.muted, letterSpacing:1, marginBottom:6 }}>
                    {item.size}{item.colorName ? ` · ${item.colorName}` : ''}
                  </p>
                  <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:300, fontSize:13 }}>₩{item.price.toLocaleString()}</p>
                </div>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:10 }}>
                  <div style={{ display:'flex', alignItems:'center', border:`1px solid ${C.border}` }}>
                    <button onClick={() => updateQty(item.key, item.quantity-1)} style={{ width:30, height:30, background:'none', border:'none', cursor:'pointer', fontSize:16, color:C.ink }}>−</button>
                    <span style={{ width:28, textAlign:'center', fontFamily:"'Pretendard',sans-serif", fontSize:12 }}>{item.quantity}</span>
                    <button onClick={() => updateQty(item.key, item.quantity+1)} style={{ width:30, height:30, background:'none', border:'none', cursor:'pointer', fontSize:16, color:C.ink }}>+</button>
                  </div>
                  <button onClick={() => removeItem(item.key)} style={{ background:'none', border:'none', cursor:'pointer', fontFamily:"'Pretendard',sans-serif", fontSize:10, color:C.muted, letterSpacing:1, textDecoration:'underline' }}>삭제</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div style={{ padding:'20px 28px', borderTop:`1px solid ${C.border}` }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:16 }}>
              <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, letterSpacing:2, color:C.muted }}>소계</span>
              <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:18 }}>₩{total.toLocaleString()}</span>
            </div>
            <button
              onClick={() => { setCartOpen(false); onCheckout(); }}
              style={{ width:'100%', padding:'15px 0', background:C.ink, color:C.bg, border:'none', cursor:'pointer', fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:11, letterSpacing:3, transition:'opacity .18s' }}
              onMouseEnter={e => e.currentTarget.style.opacity='.85'}
              onMouseLeave={e => e.currentTarget.style.opacity='1'}
            >주문하기</button>
          </div>
        )}
      </div>
    </>
  );
}
